
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';

import TableView from '../Table/Table';
import { isoAdminHeadings,isoHeadings,tableHeadings } from '../../../utils/constants';
import { fetchAllClients, fetchClient, filteredData, setEdited, setModified } from '../../../redux/actions/IsoActions';
import { fetchMerchantByClient } from '../../../redux/actions/MerchantActions';
import { connect } from "react-redux";
import moment from 'moment';
import { setMerchantEdit, setMerchantID } from '../../../redux/actions/MerchantActions';

import { Panel, PanelBody, PanelHeader } from "../../header/panel/panel"


const ISOView = (props) => {


    const navigate = useNavigate()

    const heading = Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 6 ? isoAdminHeadings : isoHeadings // eslint-fix: preserve loose-equality coercion
    const merchantHeading =  Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 6 || Number(props.LOGINREDUCER.USER.role) === 7 ? tableHeadings.adminMerchantsSubList : tableHeadings.merchantsSubList; // eslint-fix: preserve loose-equality coercion



    useEffect(() => {
        let isoID = props.ISOREDUCER.isoID;
        if (isoID) {
            props.fetchClient(isoID)
            props.fetchMerchantByClient(isoID)

        }
        props.setModified(false)
        return () => {
            props.setEdited(false)
        }
    }, [])

    const handleEditClick = () => {
        navigate('/iso/edit')
    }

    const handleMerchantClick = (value) => {
        props.setMerchantID(value.data.merchantID)

        navigate('/merchant/view')

    }


    return (

        <div className="row mb-3">

            <div className="col-xl-4">

                <Panel>

                    <PanelHeader>

                        <div className="row mb-0">

                            <div className="col-xl-10">
                                <b>
                                    ISO PROFILE
                                </b>
                            </div>

                            <div className="col-xl-2">

                                {Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 6 ? <button className='btn btn-secondary d-block w-30 btn-xs h-9px fs-11px' onClick={handleEditClick}>Edit</button> : null}{/* eslint-fix: preserve loose-equality coercion */}

                            </div>

                        </div>


                    </PanelHeader>

                    <PanelBody>

                        <div className="table-responsive">

                            <table className="table mb-0">
                                <tbody>

                                    {props.ISOREDUCER.clientData && props.ISOREDUCER.clientData.length ?
                                        Object.keys(heading).map(data => {
                                            let key = data.includes('contact') || data.includes("address") ? data.split(".") : data
                                            if (typeof (key) !== 'object') {
                                                if (props.ISOREDUCER.clientData[0][key] && props.ISOREDUCER.clientData[0][key].toString()) {
                                                    if (data === 'isoStatus') {
                                                        return (
                                                            <tr key={data}>
                                                                <th>{heading[data]}</th>
                                                                <th>:</th>
                                                                <td className={Number(props.ISOREDUCER.clientData[0][key]) === 1 ? 'approved' : Number(props.ISOREDUCER.clientData[0][key]) === 2 ? 'suspended' : Number(props.ISOREDUCER.clientData[0][key]) === 3 ? 'inactive' : 'reject'}>{Number(props.ISOREDUCER.clientData[0][key]) === 1 ? 'Active' : Number(props.ISOREDUCER.clientData[0][key]) === 2 ? 'Suspended' : Number(props.ISOREDUCER.clientData[0][key]) === 3 ? 'InAcive' : 'Deleted'}</td>
                                                            </tr>
                                                        )
                                                    } else {
                                                        return (
                                                            <tr key={data}>
                                                                <th>{heading[data]}</th>
                                                                <th>:</th>
                                                                <td>{key.toLowerCase() === ('createdate') || key.toLowerCase() === ('lastupdated') ? moment(props.ISOREDUCER.clientData[0][key]).format('MMM DD, YYYY HH:MM:SS') : props.ISOREDUCER.clientData[0][key]}</td>
                                                            </tr>
                                                        )
                                                    }
                                                }
                                            } else {
                                                if (props.ISOREDUCER.clientData[0][key[0]][key[1]]) {
                                                    return (
                                                        <tr key={data}>
                                                            <th>{heading[data]}</th>
                                                            <th>:</th>
                                                            <td>{props.ISOREDUCER.clientData[0][key[0]][key[1]] ? props.ISOREDUCER.clientData[0][key[0]][key[1]] : '-'}</td>
                                                        </tr>
                                                    )
                                                }
                                            }
                                            return null
                                        }
                                        ) : null}
                                </tbody>
                            </table>
                        </div>

                    </PanelBody>
                </Panel>


            </div>

            <div className="col-xl-8">

                <Panel>
                    <PanelHeader><b>MERCHANTS</b></PanelHeader>
                    <TableView height={600} headings={merchantHeading} data={props.MERCHANTREDUCER.allMerchants} handleClick={handleMerchantClick} />
                </Panel>
            </div>

        </div>

    )
}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    fetchAllClients,
    fetchClient,
    filteredData,
    setEdited,
    setMerchantEdit,
    setMerchantID,
    setModified,
    fetchMerchantByClient
}


export default connect(mapStateToProps, mapDispatchToProps)(ISOView);